module.exports = __webpack_public_path__ + "img/zs_bg.15344160.png";